import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { homePath, NO_ACCESS_PATH } from '../lib/home';

// Landing page for an account whose operator row holds no page permission at
// all (no booking_staff_access, no runs, no reports). Rare: it means someone
// linked an auth user to an operator without granting anything yet. Anyone
// who does hold a page is sent there instead.
export function NoAccessScreen() {
  const { operator, session, signOut, can } = useAuth();
  const home = homePath(can);
  if (home !== NO_ACCESS_PATH) return <Navigate to={home} replace />;
  const email = operator?.email ?? session?.user?.email ?? '';
  return (
    <div className="screen">
      <h1 className="payments-title">Geen toegang</h1>
      <p className="muted">
        Dit account ({email}) heeft nog geen pagina's toegewezen gekregen. Vraag een beheerder om
        de juiste rechten te zetten.
      </p>
      <div>
        <button className="btn-link" onClick={signOut}>Uitloggen</button>
      </div>
    </div>
  );
}
